import React from "react";

const Features = () => {
  return (
    <div id="feature">
      <div
        className="features  mt-5 mb-5"
        style={{ position: "relative", zIndex: "-1", overflow: "hidden" }}
      >
        {/* <div className="animate-3" style={{ right: "30px", top: "3%" }}>
        <img src="/assets/images/animate-2.svg" alt="capsule-1" />
      </div> */}
        <div className="container">
          <div className="row">
            <div className="mb-5">
              <h2 className="mb-3" data-aos="zoom-in" data-aos-duration="1000">
                Key Features
              </h2>

              <p data-aos="zoom-in" data-aos-duration="1100">
                Gain invaluable predictive analytics and actionable insights,
                empowering your team to make data-driven decisions and close
                deal.
              </p>
            </div>
            <div className="col-lg-4 mb-4">
              <div
                className="cards"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="text-center mb-4">
                  <img src="/assets/images/card-1.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Multi-Token Support</h3>
                <p>
                  Trade any ERC20 tokens on Ethereum and SPL tokens on Solana.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1300"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-2.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Partial Completions</h3>
                <p>
                  Execute deals in stages, allowing flexibility and efficient
                  liquidity management.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1300"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-3.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Vesting Schedules</h3>
                <p>
                  Customize token release schedules to align with strategic
                  goals and partnerships.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1400"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-4.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Referral System</h3>
                <p>
                  Earn rewards by referring others to the platform, fostering
                  community growth.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1400"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-5.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Time-Bound Deals</h3>
                <p>
                  Set expiration times to ensure timely execution and prevent
                  indefinite locking of assets.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1400"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-6.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">Security Measures</h3>
                <p>
                  Benefit from audited smart contracts, safe transfer methods,
                  and reentrancy guards.
                </p>
              </div>
            </div>
            {/* <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="2600"
            >
              <div className="cards">
                <div className="text-center mb-4">
                  <img src="/assets/images/card-7.svg" alt="card-1" />
                </div>
                <h3 className="mb-4">PHARMA Token Integration</h3>
                <p>
                  Utilize our native token for fee payments and participate in
                  platform governance.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="2700"
            >
              <div className="d-flex align-items-center justify-content-center ">
                <img
                  className=""
                  data-aos="fade-up"
                  data-aos-duration="2800"
                  src="/assets/images/empty-card.svg"
                  alt="card-1"
                />
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="text-center ">
                <img
                  className=""
                  data-aos="fade-up"
                  data-aos-duration="2500"
                  src="/assets/images/empty-card.svg"
                  alt="card-1"
                />
              </div>
            </div> */}
          </div>
        </div>
        <div className="animate-3" style={{ left: "30px", top: "50%" }}>
          <img src="/assets/images/animate-2.svg" alt="capsule-1" />
        </div>
      </div>
    </div>
  );
};

export default Features;
